import * as React from 'react';
import { PortalAsideLink } from '../layout/Aside/PortalAsideLink';
import { PortalAsideHeading } from '../layout/Aside/PortalAsideHeading';
import { Store } from '../store/Store';
import { StoreContext } from '../utils';

export class StatistikAside extends React.Component {
  static contextType = StoreContext;
  declare context: Store;

  render() {
    const { statistikhash } = this.context.statistikStore;

    return (
      <>
        {false && <PortalAsideLink title="Übersicht" href={`/statistik/${statistikhash}`} icon="flaticon2-architecture-and-city" />}
        {false && <PortalAsideHeading title="Aktivität" />}
        {false && <PortalAsideLink title="Protokoll" href={`/statistik/protokoll/${statistikhash}`} icon="flaticon2-graphic-1" />}

        {false && <PortalAsideLink title="Fragen" href="/statistik/fragen" icon="flaticon2-graphic-1" />}
        {false && <PortalAsideHeading title="Lernstand" />}
        {false && <PortalAsideLink title="Portfolio" href={`/statistik/portfolio/${statistikhash}`} icon="flaticon2-graphic-1" />}
        {false && <PortalAsideLink title="Entwicklung" href={`/statistik/entwicklung/${statistikhash}`} icon="flaticon2-graphic-1" />}
        {false && <PortalAsideLink title="Vergleich" href={`/statistik/vergleich/${statistikhash}`} icon="flaticon2-graphic-1" />}

        <PortalAsideHeading title={<span>Weitere Statistik-Funktionen verfügbar ab Oktober 2021</span>} />
      </>
    );
  }
}
